module.exports = __webpack_public_path__ + "img/sending_4.38e7fcd9.png";